import * as React from 'react';
import PaybackTimeModal from './financials/PaybackTimeModal';

function EstimatedPaybackTime({payback_time} :any) {
  function recommendationClass(decision_color) {
    if (decision_color == 'red') {
      return 'badge-danger badge-pill'
    } else if (decision_color == 'green') {
      return 'badge-success badge-pill'
    } else {
      return 'badge-info badge-pill'
    }
  }

  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">PayBack Time</h4>
          <p className="card-description"><PaybackTimeModal /></p>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>5 years payback time price</td>
                  <td>
                    <span className={ 'badge-success badge-pill' }>
                      { payback_time.five_years_payback_time_price }
                    </span>
                   </td>
                </tr>
                <tr>
                  <td>8 years payback time price</td>
                  <td>
                    <span className={ 'badge-success badge-pill' }>
                      { payback_time.eight_years_payback_time_price }
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>10 years payback time price</td>
                  <td>
                    <span className={ 'badge-success badge-pill' }>
                      { payback_time.ten_years_payback_time_price }
                    </span>
                   </td>
                </tr>
                <tr>
                  <td>MOS payback time</td>
                  <td>
                    <span className={ (payback_time.mos_payback_time ? recommendationClass(payback_time.mos_decision_color) : '') }>
                      { payback_time.mos_payback_time }
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Current payback time</td>
                  <td>
                    <span className={ (payback_time.current_payback_time ? recommendationClass(payback_time.decision_color) : '') }>
                      { payback_time.current_payback_time }
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Decision</td>
                  <td>
                    <span className={ (payback_time.decision ? recommendationClass(payback_time.decision_color) : '') }>
                      {payback_time.decision}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EstimatedPaybackTime;
